import { useState } from "react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SwalAlert } from "../../components/index";
import { useSavedJob } from "../../actions/homeActions";

export default () => {
  const [loadingapplyapi, setLoadingapplyapi] = useState(false);
  const [valuejobslisting, setValueJobslisting] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const user = useSelector((state) => state.app.userData.userData);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const {
    data: jobsData,
    isLoading,
    isError,
    error,
    refetch,
  } = useSavedJob(user?.talent?.user_id, user?.talent?.id, currentPage);
  const { has_more_pages, total_pages } = jobsData || {};

  const mutationJob = useMutation({
    mutationFn: async (JobData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/apply-job`,
        JobData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      setLoadingapplyapi(false);
      setShowPopup(false);
      const title = data.status;
      const message = data.message;
      SwalAlert(title, message, "success");
    },
    onError: (error) => {
      setShowPopup(false);
      setLoadingapplyapi(false);
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
    },
  });
  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "long", day: "2-digit" };
    return date.toLocaleDateString("en-GB", options);
  };
  const handleApplyJob = (jobId, talentId) => {
    if (user?.role === "fan") {
      navigate("/upgrade");
      return; // Stop execution here to prevent API call
    }
    setLoadingapplyapi(true);
    setLoadingapplyapi(jobId);
    mutationJob.mutate(
      {
        job_id: jobId,
        talent_id: talentId,
      },
      {
        onSettled: () => {
          refetch();
        },
      }
    );
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading jobs: {error.message}</p>
      </div>
    );
  }
  return {
    loadingapplyapi,
    showPopup,
    currentPage,
    setCurrentPage,
    navigate,
    user,
    jobsData,
    isLoading,
    has_more_pages,
    total_pages,
    formatDate,
    handleApplyJob,
    setValueJobslisting,
    setShowPopup,
    valuejobslisting,
  };
};
